import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** Applied to a whole price row so it's clear which field the warning belongs to. */
export const missingDefaultPriceHighlightSx: SxProps<Theme> = {
  p: 1,
  borderRadius: 1,
  border: 1,
  borderColor: 'warning.main',
  bgcolor: (theme) => alpha(theme.palette.warning.main, 0.12),
};

/** Shown when a material has no default price and none was entered; without one the optimizer skips it. */
export function MissingDefaultPriceWarning() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 0.25 }}>
      <WarningAmberIcon sx={{ fontSize: 16, color: 'warning.main', mt: '1px', flexShrink: 0 }} />
      <Typography variant="caption" color="warning.main">
        No default values are available for this material. Input a price or it will not be considered during
        optimization.
      </Typography>
    </Box>
  );
}
